import { Col, Row } from 'antd';
import { config } from 'config/config';
import { FC } from 'react';
import { PlatformEnum } from 'src/shared/enums';
import { customFormatMessage } from 'utils';

const {
  CON_ARGENTINA,
  CON_BRAZIL,
  CON_CHILE,
  CON_COLOMBIA,
  CON_DEUTSCHLAND,
  CON_ITALY,
  CON_MEXICO,
  CON_PERU,
  CON_PORTUGAL,
  CON_FRANCE,
} = PlatformEnum;

const LoginExperiences: FC = () => {
  const countryPlatform = config.APP.PLATFORM;

  let logoLoginImage = null;
  let starIconImage = null;
  let commentIconImage = null;
  let iceCreamIconImage = null;

  const loadImagesByCountry = () => {
    switch (countryPlatform) {
      case CON_ARGENTINA:
        logoLoginImage = `${config.APP.MEDIA_CON}LogoRevmapSpring.png`;
        starIconImage = `${config.APP.MEDIA_CON}starRevampSpring.jpg`;
        commentIconImage = `${config.APP.MEDIA_CON}chatRevampSpring.jpg`;
        iceCreamIconImage = `${config.APP.MEDIA_CON}creamRevampSpring.jpg`;
        break;
      case CON_BRAZIL:
        logoLoginImage = `${config.APP.MEDIA_CON}LogoRevmapSpring.png`;
        starIconImage = `${config.APP.MEDIA_CON}starRevampSpring.jpg`;
        commentIconImage = `${config.APP.MEDIA_CON}chatRevampSpring.jpg`;
        iceCreamIconImage = `${config.APP.MEDIA_CON}creamRevampSpring.jpg`;
        break;
      case CON_CHILE:
        logoLoginImage = `${config.APP.MEDIA_CON}LOGO_REVAMP_NAVIDAD.svg`;
        starIconImage = `${config.APP.MEDIA_CON}STAR_ICON_REVAMP_NAVIDAD.svg`;
        commentIconImage = `${config.APP.MEDIA_CON}COMMENT_ICON_REVAMP_NAVIDAD.svg`;
        iceCreamIconImage = `${config.APP.MEDIA_CON}ICE_CREAM_ICON_REVAMP_NAVIDAD.svg`;
        break;
      case CON_COLOMBIA:
        logoLoginImage = `${config.APP.MEDIA_CON}LogoRevmapSpring.png`;
        starIconImage = `${config.APP.MEDIA_CON}starRevampSpring.jpg`;
        commentIconImage = `${config.APP.MEDIA_CON}chatRevampSpring.jpg`;
        iceCreamIconImage = `${config.APP.MEDIA_CON}creamRevampSpring.jpg`;
        break;
      case CON_DEUTSCHLAND:
        logoLoginImage = `${config.APP.MEDIA_CON}LOGO_REVAMP_AUTUMN_23.png`;
        starIconImage = `${config.APP.MEDIA_CON}STAR_ICON_REVAMP_AUTUMN_23.png`;
        commentIconImage = `${config.APP.MEDIA_CON}COMMENT_ICON_REVAMP_AUTUMN_23.png`;
        iceCreamIconImage = `${config.APP.MEDIA_CON}ICE_CREAM_ICON_REVAMP_AUTUMN_23.png`;
        break;
      case CON_ITALY:
        logoLoginImage = `${config.APP.MEDIA_CON}LOGO_REVAMP_AUTUMN_23.png`;
        starIconImage = `${config.APP.MEDIA_CON}STAR_ICON_REVAMP_AUTUMN_23.png`;
        commentIconImage = `${config.APP.MEDIA_CON}COMMENT_ICON_REVAMP_AUTUMN_23.png`;
        iceCreamIconImage = `${config.APP.MEDIA_CON}ICE_CREAM_ICON_REVAMP_AUTUMN_23.png`;
        break;
      case CON_MEXICO:
        logoLoginImage = `${config.APP.MEDIA_CON}LOGO_REVAMP_AUTUMN_23.png`;
        starIconImage = `${config.APP.MEDIA_CON}STAR_ICON_REVAMP_AUTUMN_23.png`;
        commentIconImage = `${config.APP.MEDIA_CON}COMMENT_ICON_REVAMP_AUTUMN_23.png`;
        iceCreamIconImage = `${config.APP.MEDIA_CON}ICE_CREAM_ICON_REVAMP_AUTUMN_23.png`;
        break;
      case CON_PERU:
        logoLoginImage = `${config.APP.MEDIA_CON}LogoRevmapSpring.png`;
        starIconImage = `${config.APP.MEDIA_CON}starRevampSpring.jpg`;
        commentIconImage = `${config.APP.MEDIA_CON}chatRevampSpring.jpg`;
        iceCreamIconImage = `${config.APP.MEDIA_CON}creamRevampSpring.jpg`;
        break;
      case CON_PORTUGAL:
        logoLoginImage = `${config.APP.MEDIA_CON}LOGO_REVAMP_AUTUMN_23.png`;
        starIconImage = `${config.APP.MEDIA_CON}STAR_ICON_REVAMP_AUTUMN_23.png`;
        commentIconImage = `${config.APP.MEDIA_CON}COMMENT_ICON_REVAMP_AUTUMN_23.png`;
        iceCreamIconImage = `${config.APP.MEDIA_CON}ICE_CREAM_ICON_REVAMP_AUTUMN_23.png`;
        break;
      case CON_FRANCE:
        logoLoginImage = `${config.APP.MEDIA_CON}LOGO_REVAMP_AUTUMN_23.png`;
        starIconImage = `${config.APP.MEDIA_CON}STAR_ICON_REVAMP_AUTUMN_23.png`;
        commentIconImage = `${config.APP.MEDIA_CON}COMMENT_ICON_REVAMP_AUTUMN_23.png`;
        iceCreamIconImage = `${config.APP.MEDIA_CON}ICE_CREAM_ICON_REVAMP_AUTUMN_23.png`;
        break;
      default:
        logoLoginImage = `${config.APP.MEDIA_CON}LOGO_REVAMP_AUTUMN_23.png`;
        starIconImage = `${config.APP.MEDIA_CON}STAR_ICON_REVAMP_AUTUMN_23.png`;
        commentIconImage = `${config.APP.MEDIA_CON}COMMENT_ICON_REVAMP_AUTUMN_23.png`;
        iceCreamIconImage = `${config.APP.MEDIA_CON}ICE_CREAM_ICON_REVAMP_AUTUMN_23.png`;
        break;
    }
  };

  loadImagesByCountry();

  return (
    <div className="qr-landing__login__experiences">
      <div className="image-container">
        <img
          alt="Love Isdin"
          loading="lazy"
          className="image-logo-consumer"
          src={logoLoginImage}
        />
      </div>
      <h1 className="qr-landing__login__titleConsumer">
        {customFormatMessage('landing.qr.login.experiences.title')}
      </h1>
      <Row justify="space-around">
        <Col xs={16} md={8} className="list-item">
          <img
            alt=""
            loading="lazy"
            className="experience-icon"
            src={starIconImage}
          />
          <Row className="regular-body">
            <span className="login-con--span">
              {customFormatMessage('landing.qr.login.experience1')}
            </span>
          </Row>
        </Col>
        <Col xs={16} md={8} className="list-item">
          <img
            alt=""
            loading="lazy"
            className="experience-icon"
            src={iceCreamIconImage}
          />
          <Row className="regular-body">
            <span className="login-con--span">
              {customFormatMessage('landing.qr.login.experience2')}
            </span>
          </Row>
        </Col>
        <Col xs={16} md={8} className="list-item">
          <img
            alt=""
            loading="lazy"
            className="experience-icon"
            src={commentIconImage}
          />
          <Row className="regular-body">
            <span className="login-con--span">
              {customFormatMessage('landing.qr.login.experience3')}
            </span>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default LoginExperiences;
